import Constants from '../actions/types';
import { removeMilliseconds } from '../utils';

const initialState = {
  data: [],
  importStarted: null,
  loading: false,
  message: null,
  severity: null
};

const userFilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.USER_FILES_GET_REQUEST: {
      const newState = {
        ...state,
        data: [],
        loading: true
      };

      return newState;
    }

    case Constants.USER_FILES_GET_SUCCESS: {
      // Remove the milliseconds after the '.' character before presenting the data
      const data = action.payload.map(value => removeMilliseconds(value));
      return {
        ...state,
        data,
        loading: false
      };
    }

    case Constants.USER_FILES_GET_FAILURE: {
      return {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };
    }

    case Constants.USER_FILES_CLEARERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null,
        importStarted: null
      };

      return newState;
    }

    case Constants.USER_FILES_DELETE_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.USER_FILES_IMPORT_STARTED: {
      const newState = {
        ...state,
        message: 'Import operation was started successfully.',
        severity: 'info',
        importStarted: true
      };

      return newState;
    }

    case Constants.USER_FILES_DELETE_SUCCESS: {
      const data = state.data.filter(
        item => item.userFileId !== action.payload.userFileId
      );
      return {
        ...state,
        data,
        loading: false,
        message: 'File was deleted successfully.',
        severity: 'info'
      };
    }

    case Constants.USER_FILES_UPDATE_SUCCESS: {
      const updated = removeMilliseconds(action.payload);
      const data = state.data.map(item => {
        if (item.userFileId !== action.payload.userFileId) {
          return item;
        } else {
          return { ...item, ...updated };
        }
      });
      return {
        ...state,
        data,
        loading: false
      };
    }

    case Constants.USER_FILES_DELETE_FAILURE: {
      return {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };
    }

    case Constants.ENTITIES_IMPORT_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }

    case Constants.ENTITIES_IMPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };
    }

    default: {
      return state;
    }
  }
};

export default userFilesReducer;
